<template>
	<div class="callback">
		<div class="container">
			<div v-if="!error">
				<h2>האימות בוצע בהצלחה!</h2>
				<p>שומר נתונים ומחזיר אותך לעמוד הראשי...</p>
				<div class="loader"></div>
			</div>
			<div v-else class="error-container">
				<h2 class="error-title">אין גישה למערכת</h2>
				<p class="error-text">{{ error }}</p>
				<p class="error-instruction">נא לפנות לבעלי המערכת לקבלת הרשאה.</p>
				<button @click="goHome" class="home-btn">חזרה לדף הבית</button>
			</div>
		</div>
	</div>
</template>

<script>
import AuthService from '@/services/auth';

export default {
	name: 'CallbackPage',
	data() {
		return {
			isProcessing: false,  // מניעת כפילות בקשות
			error: null
		};
	},
	methods: {
		goHome() {
			this.$router.push('/');
		}
	},
	async mounted() {
		const urlParams = new URLSearchParams(window.location.search);
		const code = urlParams.get('code');

		if (code && !this.isProcessing) {
			this.isProcessing = true;  // סימון שהתחלנו לעבד את הבקשה

			try {
				// בדיקה אם כבר שלחנו את הקוד הזה (שמירה ב-sessionStorage)
				const processedCode = sessionStorage.getItem('processedAuthCode');
				if (processedCode === code) {
					console.warn('Authorization code already processed');
					this.$router.push('/');
					return;
				}

				const response = await fetch(`${process.env.VUE_APP_API_URL}/callback?code=${code}`);

				if (response.status === 403) {
					const data = await response.json();
					this.error = `המשתמש ${data.email || ''} אינו מורשה להשתמש במערכת.`;
					return;
				}

				if (!response.ok) throw new Error('Failed to fetch token');
				const tokens = await response.json();        // שמירת הטוקן ב-localStorage
				AuthService.saveToken(JSON.stringify(tokens));

				// שמירת הקוד שכבר עובד
				sessionStorage.setItem('processedAuthCode', code);

				// בדיקה אם יש URL ממתין עם העדפות קודמות
				const pendingUrl = localStorage.getItem('pendingVideoUrl');
				const hasPendingUpload = pendingUrl !== null;

				// אם יש לנו העדפות קודמות, נתן להן להישאר בלוקל סטורג' כדי שדף הבית יטפל בהן
				// אחרת, נמחק כל נתון ישן כדי למנוע בעיות
				if (!hasPendingUpload) {
					localStorage.removeItem('pendingVideoUrl');
					localStorage.removeItem('pendingFormatType');
					localStorage.removeItem('pendingQualityPreference');
					localStorage.removeItem('pendingContentKind');
				}

				// חזרה לדף הראשי
				this.$router.push('/');
			} catch (error) {
				console.error('Auth error:', error);
				alert('שגיאה בתהליך האימות. נא לנסות שוב.');
				this.$router.push('/');
			}
		} else if (!code) {
			this.$router.push('/');
		}
	}
};
</script>

<style scoped>
.container {
	max-width: 500px;
	margin: 100px auto;
	background-color: white;
	padding: 30px;
	border-radius: 12px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	text-align: center;
}

h2 {
	color: #4285F4;
	margin-bottom: 20px;
}

.error-title {
	color: #d32f2f;
}

.error-text {
	font-weight: bold;
	margin-bottom: 10px;
}

.error-instruction {
	margin-bottom: 20px;
	color: #666;
}

.home-btn {
	background-color: #4285F4;
	color: white;
	border: none;
	padding: 10px 20px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
}

.home-btn:hover {
	background-color: #3367d6;
}

.loader {
	border: 4px solid #f3f3f3;
	border-top: 4px solid #4285F4;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	animation: spin 1s linear infinite;
	margin: 20px auto;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
